/*
 * @Description: 车载设备管理 配置
 * @Date: 2026-09-16
 */

import { ref } from '@vue/runtime-dom'
import { enumToOption } from '@/utils'

// 管控模式：1-自动 2-手动 3-暂停
export enum controlModeEnum {
  自动 = 1,
  手动,
  暂停
}
export const controlModeOption = enumToOption(controlModeEnum)

// 表格配置
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: true,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    height: null,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'deviceFactoryName',
      label: '厂商及设备型号',
      width: '160',
      formatter: (row: any) => {
        const text = [row.deviceFactoryName, row.deviceMaintainName]
          .filter(Boolean)
          .join('-')
        return text || '-'
      }
    },
    {
      key: 'deviceNo',
      label: '设备编号',
      width: '140'
    },
    {
      key: 'carNo',
      label: '车牌号',
      width: '120'
    },
    {
      key: 'companyName',
      label: '所属企业',
      width: '140'
    },
    {
      key: 'controlMode',
      label: '管控模式',
      width: '100',
      slot: 'controlMode'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160'
    },
    {
      key: 'effectiveStartTime',
      label: '有效起止日期',
      width: '180',
      slot: 'effectiveDate'
    },
    {
      key: 'remark',
      label: '备注',
      width: '120'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'input',
    label: '设备编号',
    key: 'deviceNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '车牌号',
    key: 'carNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    // 企业名称较长，与转移复制页的企业下拉保持一致宽度
    inputWidth: 340,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'slot',
    label: '设备型号',
    key: 'deviceMaintainUuid',
    value: '',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '管控模式',
    key: 'controlMode',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: controlModeOption
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}
